import MediaHandler, {
  MEDIA_TYPE,
  TYPE_IDENTIFIER,
} from '@/helpers/MediaHandler';
import Requests from '@/helpers/Request';
import { assembleUrl } from '@/mixins/queryAssembler';
import router from '@/router';
import device from './device';
import store from '@/store';

export const NAV_TYPE = {
  BACK: 'back',
  HOME: 'home',
};

const parseMainMenuItem = (item) => {
  const url = item.url;
  const lowerUrl = url.toLowerCase();
  console.log('navigation: url: ', url);
  if (url.includes('iFrame')) {
    return {
      type: MEDIA_TYPE.WEBSITE,
      url: MediaHandler.assembleWebsiteQuery(item),
    };
  }
  if (url.includes('iFrame')) {
    return {
      type: MEDIA_TYPE.IMAGE,
      url: MediaHandler.assembleBasicInfoAppImageQuery(item),
    };
  }
  if (url.includes('media')) {
    return {
      type: MEDIA_TYPE.WEBSITE,
      url: MediaHandler.assembleSocketVideoQuery(item),
    };
  }
  if (lowerUrl.includes('submenu') || url.includes('SubMenu')) {
    return {
      type: MEDIA_TYPE.SUBMENU,
      url: MediaHandler.assembleSubMenuUrl(item),
    };
  }
  if (url.includes('tv')) {
    return {
      type: MEDIA_TYPE.TV,
      url: { name: 'TVPlayer' },
    };
  }
  if (url.includes('radio')) {
    return {
      type: MEDIA_TYPE.RADIO,
      url: { name: 'RadioPlayer' },
    };
  }
  if (url.includes('epg')) {
    return {
      type: MEDIA_TYPE.EPG,
      url: { name: 'EPGGuide' },
    };
  }
  if (url.includes('vod')) {
    return {
      type: MEDIA_TYPE.VOD,
      url: { name: 'Vod' },
    };
  }
  if (url.includes('welcome')) {
    return {
      type: MEDIA_TYPE.WELCOME,
      url: { name: 'Welcome' },
    };
  }
  if (url.includes(TYPE_IDENTIFIER.INPUT_SOURCE)) {
    return {
      type: MEDIA_TYPE.INPUT_SOURCE,
      url: { name: 'InputSource', params: item.config },
    };
  }
  if (url.includes(TYPE_IDENTIFIER.SOURCE_SELECT)) {
    return {
      type: MEDIA_TYPE.SOURCE_SELECT,
      url: { name: 'SourceSelect', params: item.config },
    };
  }
  console.log('ITEM: ', item);
  return {};
};

export default {
  namespaced: true,
  state: () => ({
    isLanguageSelected: false,
    mainMenu: [],
    mainMenuSelectedItemIndex: 0,
    activeSubMenuId: '',
    subMenuMap: {
      language: {
        lang: {
          en: {
            title: 'Select Language',
          },
          de: {
            title: 'Sprache auswählen',
          },
          ch_de: {
            title: 'Sprache auswählen',
          },
          ch_fr: {
            title: 'Choisir la langue',
          },
          ch_it: {
            title: 'Selezionare la lingua',
          },
          fr: {
            title: 'Choisir la langue',
          },
          it: {
            title: 'Selezionare la lingua',
          },
          es: {
            title: 'Seleccione el idioma',
          },
          ru: {
            title: "Выберите язык",
          },
          tr: {
            title: 'Dil Seçiniz',
          },
          nl: {
            title: 'Selecteer taal',
          },
          ar: {
            title: 'اختر اللغة',
          },
          ko: {
            title: '언어 선택',
          },
          el: {
            title: 'Επιλέξτε γλώσσα',
          },
          pt: {
            title: 'Selecionar a língua',
          },
          hu: {
            title: 'Nyelv kiválasztása',
          },
          da: {
            title: 'Vælg sprog',
          },
          sv: {
            title: 'Välj språk',
          },
 /*         encodeURI: {
            title: '?',
          },*/
        },
        items: [
          {
            icon: process.env.HOST + '/static/img/language/icons/en.png',
            lang: {
              en: {
                title: 'English',
                description: 'Select system language',
              },
              de: {
                title: 'English',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'English',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'English',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'English',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'English',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'English',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'English',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'English',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'English',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'English',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'English',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'English',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'English',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'English',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'English',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'English',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'English',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'en',
            dateISO: 'en-GB',
            type: 'language',
            position: 1,
            show: true,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/de.png',
            lang: {
              en: {
                title: 'German',
                description: 'Select system language',
              },
              de: {
                title: 'German',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'German',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'German',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'German',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'German',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'German',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'German',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'German',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'German',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'German',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'German',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'German',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'German',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'German',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'German',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'German',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'German',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'de',
            dateISO: 'de-DE',
            type: 'language',
            position: 1,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/ch_de.png',
            lang: {
              en: {
                title: 'Schweiz',
                description: 'Select system language',
              },
              de: {
                title: 'Schweiz',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Schweiz',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Schweiz',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Schweiz',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Schweiz',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Schweiz',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Schweiz',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Schweiz',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Schweiz',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Schweiz',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Schweiz',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Schweiz',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Schweiz',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Schweiz',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Schweiz',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Schweiz',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Schweiz',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'ch_de',
            dateISO: 'de-CH',
            type: 'language',
            position: 2,
            show: true,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/ch_fr.png',
            lang: {
              en: {
                title: 'Suisse',
                description: 'Select system language',
              },
              de: {
                title: 'Suisse',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Suisse',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Suisse',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Suisse',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Suisse',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Suisse',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Suisse',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Suisse',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Suisse',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Suisse',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Suisse',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Suisse',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Suisse',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Suisse',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Suisse',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Suisse',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Suisse',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'ch_fr',
            dateISO: 'fr-CH',
            type: 'language',
            position: 3,
            show: true,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/ch_it.png',
            lang: {
              en: {
                title: 'Svizzera',
                description: 'Select system language',
              },
              de: {
                title: 'Svizzera',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Svizzera',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Svizzera',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Svizzera',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Svizzera',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Svizzera',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Svizzera',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Svizzera',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Svizzera',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Svizzera',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Svizzera',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Svizzera',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Svizzera',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Svizzera',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Svizzera',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Svizzera',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Svizzera',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'ch_it',
            dateISO: 'it-CH',
            type: 'language',
            position: 4,
            show: true,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/fr.png',
            lang: {
              en: {
                title: 'France',
                description: 'Select system language',
              },
              de: {
                title: 'France',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'France',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'France',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'France',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'France',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'France',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'France',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'France',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'France',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'France',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'France',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'France',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'France',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'France',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'France',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'France',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'France',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'fr',
            dateISO: 'fr-FR',
            type: 'language',
            position: 5,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/it.png',
            lang: {
              en: {
                title: 'Italy',
                description: 'Select system language',
              },
              de: {
                title: 'Italy',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Italy',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Italy',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Italy',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Italy',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Italy',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Italy',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Italy',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Italy',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Italy',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Italy',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Italy',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Italy',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Italy',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Italy',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Italy',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Italy',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'it',
            dateISO: 'it-IT',
            type: 'language',
            position: 6,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/es.png',
            lang: {
              en: {
                title: 'Spanish',
                description: 'Select system language',
              },
              de: {
                title: 'Spanish',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Spanish',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Spanish',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Spanish',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Spanish',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Spanish',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Spanish',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Spanish',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Spanish',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Spanish',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Spanish',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Spanish',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Spanish',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Spanish',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Spanish',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Spanish',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Spanish',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'es',
            dateISO: 'es-ES',
            type: 'language',
            position: 5,
            show: true,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/tr.png',
            lang: {
              en: {
                title: 'Turkish',
                description: 'Select system language',
              },
              de: {
                title: 'Turkish',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Turkish',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Turkish',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Turkish',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Turkish',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Turkish',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Turkish',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Turkish',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Turkish',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Turkish',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Turkish',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Turkish',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Turkish',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Turkish',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Turkish',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Turkish',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Turkish',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'tr',
            dateISO: 'tr-TR',
            type: 'language',
            position: 6,
            show: true,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/ru.png',
            lang: {
              en: {
                title: 'Russian',
                description: 'Select system language',
              },
              de: {
                title: 'Russian',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Russian',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Russian',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Russian',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Russian',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Russian',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Russian',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Russian',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Russian',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Russian',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Russian',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Russian',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Russian',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Russian',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Russian',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Russian',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Russian',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'ru',
            dateISO: 'ru-RU',
            type: 'language',
            position: 7,
            show: true,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/nl.png',
            lang: {
              en: {
                title: 'Dutch',
                description: 'Select system language',
              },
              de: {
                title: 'Dutch',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Dutch',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Dutch',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Dutch',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Dutch',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Dutch',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Dutch',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Dutch',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Dutch',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Dutch',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Dutch',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Dutch',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Dutch',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Dutch',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Dutch',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Dutch',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Dutch',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'nl',
            dateISO: 'nl-NL',
            type: 'language',
            position: 8,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/sy.png',
            lang: {
              en: {
                title: 'Arabic',
                description: 'Select system language',
              },
              de: {
                title: 'Arabic',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Arabic',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Arabic',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Arabic',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Arabic',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Arabic',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Arabic',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Arabic',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Arabic',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Arabic',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Arabic',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Arabic',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Arabic',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Arabic',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Arabic',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Arabic',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Arabic',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'ar',
            dateISO: 'ar-SY',
            type: 'language',
            position: 9,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/kr.png',
            lang: {
              en: {
                title: 'Korean',
                description: 'Select system language',
              },
              de: {
                title: 'Korean',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Korean',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Korean',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Korean',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Korean',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Korean',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Korean',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Korean',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Korean',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Korean',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Korean',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Korean',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Korean',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Korean',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Korean',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Korean',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Korean',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'ko',
            dateISO: 'ko-KR',
            type: 'language',
            position: 10,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/gr.png',
            lang: {
              en: {
                title: 'Greek',
                description: 'Select system language',
              },
              de: {
                title: 'Greek',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Greek',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Greek',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Greek',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Greek',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Greek',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Greek',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Greek',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Greek',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Greek',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Greek',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Greek',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Greek',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Greek',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Greek',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Greek',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Greek',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'el',
            dateISO: 'el-GR',
            type: 'language',
            position: 11,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/pt.png',
            lang: {
              en: {
                title: 'Portuguese',
                description: 'Select system language',
              },
              de: {
                title: 'Portuguese',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Portuguese',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Portuguese',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Portuguese',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Portuguese',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Portuguese',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Portuguese',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Portuguese',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Portuguese',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Portuguese',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Portuguese',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Portuguese',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Portuguese',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Portuguese',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Portuguese',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Portuguese',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Portuguese',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'pt',
            dateISO: 'pt-PT',
            type: 'language',
            position: 12,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/hu.png',
            lang: {
              en: {
                title: 'Hungarian',
                description: 'Select system language',
              },
              de: {
                title: 'Hungarian',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Hungarian',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Hungarian',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Hungarian',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Hungarian',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Hungarian',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Hungarian',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Hungarian',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Hungarian',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Hungarian',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Hungarian',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Hungarian',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Hungarian',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Hungarian',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Hungarian',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Hungarian',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Hungarian',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'hu',
            dateISO: 'hu-HU',
            type: 'language',
            position: 13,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/dk.png',
            lang: {
              en: {
                title: 'Danish',
                description: 'Select system language',
              },
              de: {
                title: 'Danish',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Danish',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Danish',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Danish',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Danish',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Danish',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Danish',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Danish',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Danish',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Danish',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Danish',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Danish',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Danish',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Danish',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Danish',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Danish',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Danish',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'da',
            dateISO: 'da-DK',
            type: 'language',
            position: 14,
            show: false,
          },
          {
            icon: process.env.HOST + '/static/img/language/icons/se.png',
            lang: {
              en: {
                title: 'Swedish',
                description: 'Select system language',
              },
              de: {
                title: 'Swedish',
                description: 'Wähle Systemsprache',
              },
              ch_de: {
                title: 'Swedish',
                description: 'Wähle Systemsprache',
              },
              ch_fr: {
                title: 'Swedish',
                description: 'Sélectionner la langue du système',
              },
              ch_it: {
                title: 'Swedish',
                description: 'Selezionare la lingua del sistema',
              },
              fr: {
                title: 'Swedish',
                description: 'Sélectionner la langue du système',
              },
              it: {
                title: 'Swedish',
                description: 'Selezionare la lingua del sistema',
              },
              es: {
                title: 'Swedish',
                description: 'Seleccione el idioma del sistema',
              },
              ru: {
                title: 'Swedish',
                description: "Выберите язык системы",
              },
              tr: {
                title: 'Swedish',
                description: 'Sistem dilini seçin.',
              },
              nl: {
                title: 'Swedish',
                description: 'Systeemtaal selecteren.',
              },
              ar: {
                title: 'Swedish',
                description: 'اللغة العربية',
              },
              ko: {
                title: 'Swedish',
                description: '시스템 언어 선택',
              },
              el: {
                title: 'Swedish',
                description: 'Επιλογή γλώσσας συστήματος',
              },
              pt: {
                title: 'Swedish',
                description: 'Selecionar o idioma do sistema',
              },
              hu: {
                title: 'Swedish',
                description: 'Válassza ki a rendszer nyelvét',
              },
              da: {
                title: 'Swedish',
                description: 'Vælg systemsprog',
              },
              sv: {
                title: 'Swedish',
                description: 'Välj systemspråk',
              },
            },
            thumbnail: process.env.HOST + '/static/img/language/thumbnail.png',
            iso: 'sv',
            dateISO: 'sv-SE',
            type: 'language',
            position: 15,
            show: false,
          },
        ],
        currentIndex: 0,
      },
      ambient: {
        title: 'Ambient',
        items: [
          {
            name: 'Activate',
            thumbnail: process.env.HOST + '/static/img/ambient/activate.png',
            description:
              'With each environment the light of the room, the music and the images of the TV are personalized',
          },
          {
            name: 'Sport',
            thumbnail: process.env.HOST + '/static/img/ambient/sport.png',
            description:
              'With each environment the light of the room, the music and the images of the TV are personalized',
          },
          {
            name: 'Relax',
            thumbnail: process.env.HOST + '/static/img/ambient/relax.png',
            description:
              'With each environment the light of the room, the music and the images of the TV are personalized',
          },
          {
            name: 'Romantic',
            thumbnail: process.env.HOST + '/static/img/ambient/romantic.png',
            description:
              'With each environment the light of the room, the music and the images of the TV are personalized',
          },
        ],
        backgroundImage: process.env.HOST + '/static/img/ambient/bg.png',
        currentIndex: 0,
      },
      fitness: {
        items: [],
        backgroundImage: process.env.HOST + '/static/img/fitness/bg.png',
        currentIndex: 0,
      },
      tourism: {
        items: [],
        backgroundImage: process.env.HOST + '/static/img/tourism/bg.png',
        currentIndex: 0,
      },
      demo: {
        lang: {
          en: {
            title: 'Demo',
          },
          de: {
            title: 'Demo',
          },
          ch_de: {
            title: 'Demo',
          },
          ch_it: {
            title: 'Demo',
          },
          ch_fr: {
            title: 'Démo',
          },
          fr: {
            title: 'Démo',
          },
          it: {
            title: 'Demo',
          },
          es: {
            title: 'Demo',
          },
          ru: {
            title: 'Demo',
          },
          tr: {
            title: 'Demo',
          },
          nl: {
            title: 'Demo',
          },
          ar: {
            title: 'عرض توضيحي',
          },
          ko: {
            title: '데모',
          },
          el: {
            title: 'Demo',
          },
          pt: {
            title: 'Demonstração',
          },
          hu: {
            title: 'Demo',
          },
          da: {
            title: 'Demo',
          },
          sv: {
            title: 'Demo',
          },
        },
        items: [
          {
            lang: {
              en: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              de: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ch_de: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ch_it: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ch_fr: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              fr: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              it: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              es: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ru: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              tr: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              nl: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ar: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ko: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              el: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              pt: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              hu: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              da: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              sv: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
            },
            name: 'TV Channel IGMP',
            type: 'tv',
            position: 14,
            show: true,
            actionUrl: {
              dvb_type: '',
              url: 'igmp://239.100.100.102:4444',
              name: 'Das Erste HD',
              serviceId: 10301,
              buildingId: 2,
              originalNetworkId: 1,
              transportStreamId: 1019,
              gateway_id: '5943e233f072299b370bbe77',
              serviceType: 'tv',
              position: 2,
              price: '0.00',
              frequency: '',
              symbolRate: '',
              tags: [],
              frequencyInKhz: '0',
              packages: ['tv-#1'],
              epgChannelId: 25,
              id: '5b1f7c4a7e521a000fa864a7',
            },
          },
          {
            lang: {
              en: {
                title: 'Info',
                description: 'Show TV Info',
              },
              de: {
                title: 'Info',
                description: 'Show TV Info',
              },
              ch_de: {
                title: 'Info',
                description: 'Show TV Info',
              },
              ch_it: {
                title: 'Info',
                description: 'Show TV Info',
              },
              ch_fr: {
                title: 'Info',
                description: 'Show TV Info',
              },
              fr: {
                title: 'Info',
                description: 'Show TV Info',
              },
              it: {
                title: 'Info',
                description: 'Show TV Info',
              },
              es: {
                title: 'Info',
                description: 'Show TV Info',
              },
              ru: {
                title: 'Info',
                description: 'Show TV Info',
              },
              tr: {
                title: 'Info',
                description: 'Show TV Info',
              },
              nl: {
                title: 'Info',
                description: 'Show TV Info',
              },
              ar: {
                title: 'Info',
                description: 'Show TV Info',
              },
              ko: {
                title: 'Info',
                description: 'Show TV Info',
              },
              el: {
                title: 'Info',
                description: 'Show TV Info',
              },
              pt: {
                title: 'Info',
                description: 'Show TV Info',
              },
              hu: {
                title: 'Info',
                description: 'Show TV Info',
              },
              da: {
                title: 'Info',
                description: 'Show TV Info',
              },
              sv: {
                title: 'Info',
                description: 'Show TV Info',
              },
            },
            name: 'Info',
            thumbnail: process.env.HOST + '/static/img/ambient/activate.png',
            description: 'Show TV Info',
            type: 'internal',
            position: 2,
            show: true,
            actionUrl: '/info',
          },
          {
            lang: {
              en: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              de: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              ch_de: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              ch_it: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              ch_fr: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              fr: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              it: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              es: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              ru: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              tr: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              nl: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              ar: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              ko: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              el: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              pt: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              hu: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              da: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
              sv: {
                title: 'Info Keyhandling',
                description: 'Show TV Keyhandling',
              },
            },
            name: 'Info Keyhandling',
            thumbnail: process.env.HOST + '/static/img/ambient/activate.png',
            description: 'Show TV Keyhandling',
            type: 'internal',
            position: 3,
            show: true,
            actionUrl: '/info/keyhandling',
          },
          {
            lang: {
              en: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              de: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              ch_de: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              ch_it: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              ch_fr: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              fr: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              it: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              es: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              ru: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              tr: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              nl: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              ar: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              ko: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              el: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              pt: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              hu: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              da: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
              sv: {
                title: 'Ambient Menu',
                description: 'Demo of the Ambient menu',
              },
            },
            name: 'Ambient Menu',
            thumbnail: process.env.HOST + '/static/img/ambient/bg.png',
            description: 'Demo of the Ambient menu',
            type: 'internal',
            position: 4,
            show: true,
            actionUrl: '/sub-menu/ambient',
          },
          {
            lang: {
              en: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              de: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              ch_de: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              ch_it: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              ch_fr: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              fr: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              it: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              es: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              ru: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              tr: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              nl: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              ar: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              ko: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              el: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              pt: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              hu: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              da: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
              sv: {
                title: 'Image Test',
                description: 'Demo of image content',
              },
            },
            name: 'Image Test',
            thumbnail: process.env.HOST + '/static/img/default.jpeg',
            description: 'Demo of image content',
            type: 'image',
            position: 5,
            show: true,
            actionUrl: process.env.HOST + '/static/img/default.jpeg',
          },
          {
            lang: {
              en: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              de: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              ch_de: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              ch_it: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              ch_fr: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              fr: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              it: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              es: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              ru: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              tr: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              nl: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              ar: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              ko: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              el: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              pt: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              hu: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              da: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
              sv: {
                title: 'Website Test',
                description: 'Demo of website content. Showing a website',
              },
            },
            name: 'Website Test',
            thumbnail: process.env.HOST + '/static/img/default.jpeg',
            description: 'Demo of website content. Showing a website',
            type: 'website',
            position: 6,
            show: true,
            actionUrl: 'https://klangundton-magazin.de/',
          },
          {
            lang: {
              en: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              de: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              ch_de: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              ch_it: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              ch_fr: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              fr: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              it: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              es: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              ru: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              tr: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              nl: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              ar: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              ko: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              el: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              pt: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              hu: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              da: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
              sv: {
                title: 'Bundesliga Test',
                description: 'Demo of website content. Showing the Bundesliga website',
              },
            },
            name: 'Bundesliga Test',
            thumbnail: process.env.HOST + '/static/img/default.jpeg',
            description: 'Demo of website content. Showing the Bundesliga website',
            type: 'website',
            position: 7,
            show: true,
            actionUrl: 'https://stagingbundesligaapp.triax.biz',
          },
          {
            lang: {
              en: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              de: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ch_de: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ch_it: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ch_fr: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              fr: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              it: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              es: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ru: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              tr: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              nl: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ar: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ko: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              el: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              pt: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              hu: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              da: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              sv: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
            },
            name: 'VoD Stream',
            type: 'video',
            position: 8,
            show: true,
            description: 'Test a VoD Channel',
            actionUrl: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
          },
          {
            lang: {
              en: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              de: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              ch_de: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              ch_it: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              ch_fr: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              fr: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              it: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              es: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              ru: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              tr: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              nl: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              ar: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              ko: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              el: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              pt: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              hu: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              da: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
              sv: {
                title: 'TV Channel UDP',
                description: 'Test a TV Channel',
              },
            },
            name: 'TV Channel UDP',
            type: 'tv',
            position: 9,
            show: true,
            description: 'Test a TV Channel',
            actionUrl: 'udp://239.100.100.102:4444',
          },
          {
            lang: {
              en: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              de: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ch_de: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ch_it: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ch_fr: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              fr: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              it: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              es: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ru: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              tr: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              nl: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ar: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              ko: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              el: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              pt: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              hu: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              da: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
              sv: {
                title: 'TV Channel IGMP',
                description: 'Test a TV Channel',
              },
            },
            name: 'TV Channel IGMP',
            type: 'tv',
            position: 10,
            show: true,
            description: 'Test a TV Channel',
            actionUrl: {
              dvb_type: '',
              url: 'igmp://239.100.100.102:4444',
              name: 'Das Erste HD',
              serviceId: 10301,
              buildingId: 2,
              originalNetworkId: 1,
              transportStreamId: 1019,
              gateway_id: '5943e233f072299b370bbe77',
              serviceType: 'tv',
              position: 2,
              price: '0.00',
              frequency: '',
              symbolRate: '',
              tags: [],
              frequencyInKhz: '0',
              packages: ['tv-#1'],
              epgChannelId: 25,
              id: '5b1f7c4a7e521a000fa864a7',
            },
          },
          {
            lang: {
              en: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              de: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ch_de: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ch_it: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ch_fr: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              fr: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              it: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              es: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ru: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              tr: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              nl: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ar: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ko: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              el: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              pt: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              hu: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              da: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              sv: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
            },
            name: 'Video Bunny Test (1080p)',
            description: 'Demo of video content.',
            thumbnail: process.env.HOST + '/static/img/bunny-poster.jpeg',
            //actionUrl: process.env.HOST + '/static/video/bunny.mp4',
            actionUrl: 'https://temp.digmedia.net/website/video/bigbuckbunnyclip.mp4',
            type: 'video',
            position: 11,
            show: true,
          },
          {
            lang: {
              en: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              de: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ch_de: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ch_it: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ch_fr: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              fr: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              it: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              es: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ru: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              tr: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              nl: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ar: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ko: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              el: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              pt: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              hu: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              da: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              sv: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
            },
            name: 'Video Rain Test (720p)',
            description: 'Demo of video content.',
            //actionUrl: process.env.HOST + '/static/video/rain-h264-720p.mp4',
            actionUrl: 'https://temp.digmedia.net/website/video/bigbuckbunnyclip.mp4',
            type: 'video',
            position: 12,
            show: true,
          },
          {
            lang: {
              en: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              de: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ch_de: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ch_it: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ch_fr: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              fr: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              it: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              es: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ru: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              tr: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              nl: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ar: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ko: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              el: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              pt: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              hu: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              da: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              sv: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
            },
            name: 'Dream',
            description: 'Demo of video content.',
            actionUrl:
              'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
            type: 'video',
            position: 13,
            show: true,
          },
          {
            lang: {
              en: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              de: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              ch_de: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              ch_it: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              ch_fr: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              fr: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              it: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              es: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              ru: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              tr: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              nl: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              ar: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              ko: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              el: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              pt: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              hu: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              da: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
              sv: {
                title: 'Reload Test',
                description: 'Reload Test',
              },
            },
            name: 'Reload Test',
            description: 'Reload Test',
            type: 'reload',
            position: 1,
            show: true,
          },
        ],
        currentIndex: 0,
        backgroundImage: process.env.HOST + '/static/img/ambient/bg.png',
      },










      vod: {
        lang: {
          en: {
            title: 'VoD',
          },
          de: {
            title: 'VoD',
          },
          ch_de: {
            title: 'VoD',
          },
          ch_it: {
            title: 'VoD',
          },
          ch_fr: {
            title: 'VoD',
          },
          fr: {
            title: 'VoD',
          },
          it: {
            title: 'VoD',
          },
          es: {
            title: 'VoD',
          },
          ru: {
            title: 'VoD',
          },
          tr: {
            title: 'VoD',
          },
          nl: {
            title: 'VoD',
          },
          ar: {
            title: 'VoD',
          },
          ko: {
            title: 'VoD',
          },
          el: {
            title: 'VoD',
          },
          pt: {
            title: 'VoD',
          },
          hu: {
            title: 'VoD',
          },
          da: {
            title: 'VoD',
          },
          sv: {
            title: 'VoD',
          },
        },
        items: [
          {
            lang: {
              en: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              de: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ch_de: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ch_it: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ch_fr: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              fr: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              it: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              es: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ru: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              tr: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              nl: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ar: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ko: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              el: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              pt: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              hu: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              da: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              sv: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
            },
            name: 'VoD Stream',
            type: 'video',
            position: 8,
            show: true,
            description: 'Test a VoD Channel',
            actionUrl: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
          },
          {
            lang: {
              en: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              de: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ch_de: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ch_it: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ch_fr: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              fr: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              it: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              es: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ru: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              tr: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              nl: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ar: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ko: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              el: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              pt: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              hu: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              da: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              sv: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
            },
            name: 'Video Bunny Test (1080p)',
            description: 'Demo of video content.',
            thumbnail: process.env.HOST + '/static/img/bunny-poster.jpeg',
            //actionUrl: process.env.HOST + '/static/video/bunny.mp4',
            actionUrl: 'https://temp.digmedia.net/website/video/bigbuckbunnyclip.mp4',
            type: 'video',
            position: 11,
            show: true,
          },
          {
            lang: {
              en: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              de: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ch_de: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ch_it: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ch_fr: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              fr: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              it: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              es: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ru: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              tr: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              nl: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ar: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ko: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              el: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              pt: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              hu: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              da: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              sv: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
            },
            name: 'Video Rain Test (720p)',
            description: 'Demo of video content.',
            //actionUrl: process.env.HOST + '/static/video/rain-h264-720p.mp4',
            actionUrl: 'https://temp.digmedia.net/website/video/bigbuckbunnyclip.mp4',
            type: 'video',
            position: 12,
            show: true,
          },
          {
            lang: {
              en: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              de: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ch_de: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ch_it: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ch_fr: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              fr: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              it: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              es: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ru: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              tr: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              nl: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ar: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ko: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              el: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              pt: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              hu: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              da: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              sv: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
            },
            name: 'Dream',
            description: 'Demo of video content.',
            actionUrl:
              'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
            type: 'video',
            position: 13,
            show: true,
          },
        ],
        currentIndex: 0,
        backgroundImage: process.env.HOST + '/static/img/ambient/bg.png',
      },














    },
    nextAction: undefined,
  }),
  mutations: {
    setSelectLanguage(state) {
      state.isLanguageSelected = !state.isLanguageSelected;
    },
    setMainMenu(state, menu) {
      state.mainMenu = menu;
    },
    setSubMenu(state, submenu) {
      const subObject = {};
      subObject[submenu.id] = submenu;
      state.subMenuMap = Object.assign({}, state.subMenuMap, subObject);
      //if(state.subMenuMap[submenu.id]) {
      //} else {
      //  state.subMenuMap[submenu.id] = submenu;
      //}
    },
    resetSubMenuIndex(state, id) {
      state.subMenuMap[id].currentIndex = 0;
    },
    setMainMenuIndex(state, value = 0) {
      state.mainMenuSelectedItemIndex = value;
    },
    incMainMenuIndex(state) {
      state.mainMenuSelectedItemIndex++;
    },
    decMainMenuIndex(state) {
      state.mainMenuSelectedItemIndex--;
    },
    setSubMenuIndex(state, { id, value }) {
      state.subMenuMap[id] = Object.assign({}, state.subMenuMap[id], {
        currentIndex: value,
      });
      // state.subMenuMap[id].currentIndex = value;
    },
    setActiveSubMenuApp(state, value) {
      state.activeSubMenuId = value;
    },
    setNextAction(state, value = undefined) {
      state.nextAction = value;
    },
  },
  actions: {
    async init({ commit, dispatch, rootState }) {
      try {
        if (!rootState.buildingId) {
          await dispatch('device/init', null, { root: true });
        }
        const response = await Requests.get(
          `${process.env.API_PORTAL}/bid/${rootState.buildingId}/appmenu`
        );
        commit('setMainMenu', response);
        dispatch('tv/prepare', null, { root: true });
        //dispatch('radio/prepare', null, { root: true });
        return Promise.resolve();
      } catch (err) {
        console.log("Couldn't fetch app menu because of Error: ", err);
        return Promise.reject();
      }
    },
    mainMenuGoRight({ commit, state, getters }) {
      if (state.mainMenuSelectedItemIndex < getters.getMainMenuLength - 1) {
        commit('incMainMenuIndex');
        return;
      }
      commit('setMainMenuIndex');
    },
    mainMenuGoLeft({ commit, state, getters }) {
      if (state.mainMenuSelectedItemIndex > 0) {
        commit('decMainMenuIndex');
        return;
      }
      commit('setMainMenuIndex', getters.getMainMenuLength - 1);
    },
    resetSubMenuIndex({ state, commit }, id) {
      if (!state.subMenuMap[id]) {
        console.log('NO SUBMENU FOUND FOR ID: ', id);
        commit('setSubMenu', { id });
        return;
      } else {
        commit('resetSubMenuIndex', id);
      }
    },
    openLanguageMenu() {
      router.push('/sub-menu/language');
    },
    callMainMenu({ state, commit, dispatch, getters }) {
      if (getters.getIsLanguageSelected) {
        dispatch('openLanguageMenu');
        return;
      }

      const element = getters.getMainMenuActiveItem;

      dispatch('handleItemCall', element);
    },
    handleLoggerCall({ dispatch }, element) {
      dispatch(
        'socket/handleActionCall',
        {
          action,
          sourceapp_id: element,
        },
        {
          root: true,
        }
      );
    },
    handleItemCall({ dispatch }, element) {
      const { type, url } = parseMainMenuItem(element);

      switch (type) {
        case MEDIA_TYPE.TV:
        case MEDIA_TYPE.RADIO:
        case MEDIA_TYPE.IMAGE:
        case MEDIA_TYPE.EPG:
        case MEDIA_TYPE.VOD:
        case MEDIA_TYPE.WELCOME:
        case MEDIA_TYPE.WEBSITE:
          router.push(url);
          break;
        case MEDIA_TYPE.SUBMENU:
          router.push(url);
          break;
        case MEDIA_TYPE.INPUT_SOURCE:
          router.push(url);
          break;
        case MEDIA_TYPE.SOURCE_SELECT:
          router.push(url);
          break;
        default:
          dispatch(
            'notification/new',
            {
              title: 'Not supported Type: ' + element.type,
              message: 'This feature is currently not supported',
            },
            { root: true }
          );
      }
    },
    async getMainMenuItemById({ dispatch, state, getters }, id) {
      if (state.mainMenu.length < 1) {
        await dispatch('init').catch((err) => {
          console.log('COUld not init', err);
        });
      }
      const item = state.mainMenu.find((el) => el.id === id);
      if (!item)
        return Promise.resolve({
          lang: {},
        });
      return Promise.resolve(item);
    },
    async getSendMessageById({ dispatch, state, getters }, id) {
      return device.id;
      /*
      if (state.mainMenu.length < 1) {
        await dispatch('init').catch((err) => {
          console.log('COUld not init', err);
        });
      }
      const item = state.mainMenu.find((el) => el.id === id);
      if (!item)
        return Promise.resolve({
          lang: {},
        });
      return Promise.resolve(item);
      */
    },
    openSubSubMenu({ commit, state }, submenu) {
      if (!state.subMenuMap[submenu.id]) {
        const newSubMenu = { ...submenu, currentIndex: 0 };
        commit('setSubMenu', newSubMenu);
      }

      router.push({
        name: 'SubMenu',
        params: {
          id: submenu.id,
        },
      });
    },
    async fetchSubMenu({ state, dispatch, commit, getters }, { id }) {
      // console.log('getters ', getters);
      // console.log('CONTEXT ', id, getters.getSubMenuById(id));
      const subMenu = await dispatch('getMainMenuItemById', id);
      if (state.subMenuMap[id]) {
        if (!state.subMenuMap[id].title) {
          const mergedMenu = { ...subMenu, ...state.subMenuMap[id] };
          commit('setSubMenu', mergedMenu);
        }
        commit('setActiveSubMenuApp', id);
        // console.log('HAS SUB MENU ALREADY', getters.getSubMenuById(id));

        return Promise.resolve();
      }
      try {
        // await dispatch('init');
        // const subMenu = await dispatch('getMainMenuItemById', id);
        subMenu.items = await Requests.fetchSubMenu(id);
        subMenu.currentIndex = 0;
        subMenu.id = id;
        console.log('SUBMENU', subMenu);
        commit('setSubMenu', subMenu);
        commit('setActiveSubMenuApp', id);
      } catch (e) {
        console.log('could not fetch sub menu: ', e);
      }
      return Promise.resolve();
    },
    incSubMenu({ state, commit, getters }) {
      const index = getters.getActiveSubMenuElementIndex;
      const id = state.activeSubMenuId;
      console.log('VALUE', id);
      if (index < getters.getActiveSubMenuItemsLenght - 1) {
        commit('setSubMenuIndex', { id, value: index + 1 });
        return;
      }
      commit('setSubMenuIndex', { id, value: 0 });
    },
    decSubMenu({ state, commit, getters }) {
      const index = getters.getActiveSubMenuElementIndex;
      const id = state.activeSubMenuId;

      if (index > 0) {
        commit('setSubMenuIndex', {
          id,
          value: index - 1,
        });
        return;
      }
      commit('setSubMenuIndex', {
        id,
        value: getters.getActiveSubMenuItemsLenght - 1,
      });
    },
    selectLanguage({ commit }) {
      commit('setSelectLanguage');
    },
    handleCallBackAction({ rootState }, context) {
      if (!context.src_url) return;
      try {
        if (!context.query) fetch(context.src_url);
        const searchParams = new URLSearchParams();
        if (context.query.lang) searchParams.set('lang', rootState.lang.active);
        if (context.query.deviceId)
          searchParams.set('lang', rootState.device.buildingId);
        if (context.query.room) searchParams.set('lang', rootState.device.room);
        fetch(`${context.src_url}?${searchParams.toString()}`);
      } catch (e) {
        console.log('ERROR ON CALLBACK ACTION', e);
      }
    },
    handleNextAction({ dispatch, commit, state }) {
      const { action, data } = state.nextAction;
      switch (action) {
        case 'open_source_app':
          // dispatch(
          //   'socket/handleActionCall',
          //   {
          //     action,
          //     sourceapp_id: data.sourceapp_id,
          //   },
          //   {
          //     root: true,
          //   }
          // );
          dispatch('handleOpenSourceApp', data.sourceapp_id);
          break;
        case 'callback':
          dispatch('handleCallBackAction', data);
          router.push({ name: 'Home' });
          break;
        case 'open_app':
          dispatch('handleOpenApp', data);
          break;
        case 'send_message':
          dispatch('handleSendMessage', data);
          break;
        case 'open_welcome_screen':
        default:
          dispatch(
            'notification/new',
            {
              title: 'This Action is not supported',
              message: action,
            },
            {
              root: true,
            }
          );
          router.push({ name: 'Home' });
      }
      commit('setNextAction', null);
    },
    async handleOpenApp({ dispatch }, data) {
      const app = await dispatch('getMainMenuItemById', data.app_id);
      dispatch('handleItemCall', app);
    },
    async handleSendMessage({ dispatch }, data) {
      const app = await dispatch('getSendMessageById', data);
      dispatch('handleLoggerCall', app);
    },
    handleOpenSourceApp(_, port) {
      router.push({
        name: 'InputSource',
        params: { source: 'HDMI', port: port },
      });
    },
    handleSubMenuAction({ dispatch, commit, getters, state, rootState }) {
      console.log('SUB MENU ACTION', getters.getActiveSubMenuItemType);
      if (getters.getActiveSubMenuItem.action) {
        commit('setNextAction', getters.getActiveSubMenuItem.action);
      }
      switch (getters.getActiveSubMenuItemType) {
        case 'internal':
          router.push({ path: getters.getActiveSubMenuItemActionUrl });
          break;
        case 'image':
          router.push({
            name: 'MediaPlayer',
            query: {
              type: MEDIA_TYPE.IMAGE,
              src: encodeURI(getters.getActiveSubMenuItemActionUrl),
              alt: encodeURI(this.getDescription),
            },
          });
          break;
        case 'video':
          router.push({
            name: 'MediaPlayer',
            query: {
              type: MEDIA_TYPE.VIDEO,
              src: encodeURI(getters.getActiveSubMenuItemActionUrl),
            },
          });
          break;
        case 'youtube':
        case 'website':
          router.push({
            name: 'MediaPlayer',
            query: {
              type: MEDIA_TYPE.WEBSITE,
              src: encodeURI(getters.getActiveSubMenuItemActionUrl),
            },
          });
          break;
        case 'tv':
          router.push({
            name: 'TVPlayer',
            params: getters.getActiveSubMenuItemActionUrl && {
              src: encodeURI(
                JSON.stringify(getters.getActiveSubMenuItemActionUrl)
              ),
            },
          });
          break;
        case 'language':
          dispatch('lang/select', getters.getActiveSubMenuItem, { root: true })
            .then(() => {
              router.push({ name: 'Home' });
            })
            .catch((err) => {
              console.log('Error on select lang', err);
            });
          break;
        case 'submenu':
          dispatch('openSubSubMenu', getters.getActiveSubMenuItem);
          break;
        case 'action':
          const url = assembleUrl({
            src: getters.getActiveSubMenuItemActionUrl,
            lang: rootState.lang.active,
            room: rootState.device.room,
            deviceId: rootState.device.deviceId,
          });
          dispatch(
            'notification/new',
            {
              title: 'Call action',
              message: url,
            },
            { root: true }
          );
          Requests.get(url);
          break;
        default:
          location.reload(true);
      }
    },
    async callNextActionCallback({ state, commit, rootState, getters }) {
      console.log('--> [ACTION]: callNextActionCallback');
      if (!getters.getHasNextAction) {
        console.log('[RETURN] - Has no next action applied');
        return;
      }
      const url = assembleUrl({
        src: state.nextAction,
        lang: rootState.lang.active,
        room: rootState.device.room,
        deviceId: rootState.device.deviceId,
      });
      try {
        console.log('--> Call callback url: ', url);
        Requests.get(url);
        console.log('--> Called callback url: ', url);
      } catch (err) {
        console.log('    [ERROR]: callNextActionCallback', err);
      }
      commit('setNextAction');
    },
    to({ commit, dispatch, getters }, navigateTo) {
      // if (getters.getHasNextAction) {
      //   dispatch('callNextActionCallback');
      // }
      switch (navigateTo) {
        case NAV_TYPE.BACK:
          router.go(-1);
          break;
        case NAV_TYPE.HOME:
          router.push({ name: 'Home' });
          break;
        default:
          console.log(
            '  [ERROR]: navigation/to – Navigation target not supported',
            navigateTo,
            ' | Supported targets: ',
            NAV_TYPE
          );
      }
    },
  },
  getters: {
    getHasNextAction(state) {
      return state.nextAction !== undefined;
    },
    getMainMenu(state) {
      let roomApps = store.getters['device/getRoomAppInDevice'];
      return state.mainMenu
        .filter((e) => e.status && e.ident !== 'options' && (!e.isRoomApp || roomApps.indexOf(e.id) >= 0))
        .sort((a, b) => (a.order > b.order ? 1 : -1));
    },
    getMainMenuLength(_, getters) {
      return getters.getMainMenu.length;
    },
    getMainMenuActiveItem(state, getters) {
      return getters.getMainMenu[state.mainMenuSelectedItemIndex];
    },
    getSubMenuMap(state) {
      return state.subMenuMap;
    },
    getSubMenuById: (_, getters) => (id) => {
      if (!getters.getSubMenuMap[id]) return {};
      return getters.getSubMenuMap[id];
    },
    getActiveSubMenu(state) {
      if (!state.subMenuMap[state.activeSubMenuId]) return {};
      var subMenu = state.subMenuMap[state.activeSubMenuId];
      
      if(state.activeSubMenuId === 'language') {
        var subMenuTemp = subMenu.items;

        const langCustomizer = store.getters['customizer/getLanguages'];
        function setPos(e, i) {
          if(typeof langCustomizer[e.iso] == 'undefined') return;
          //console.log("+-+-+-+-+-+-+-+-+-SHOW e:", e.show, " langcustomizer[e.iso]:", langCustomizer[e.iso].show, " subMenuTemp[i]:", subMenuTemp[i].show);
          //console.log("+-+-+-+-+-+-+-+-+-POSITION e:", e.position, " langcustomizer[e.iso]:", langCustomizer[e.iso].position, " subMenuTemp[i]:", subMenuTemp[i].position);
          //console.log("+-+-+-+-+-+-+-+-+-ISO", e.iso);
          //console.log("+-+-+-+-+-+-+-+-+-I", i);
          subMenuTemp[i].position = langCustomizer[e.iso].position;
          subMenuTemp[i].show = langCustomizer[e.iso].show;
          //console.log("*****************subMenuTemp", subMenuTemp[i]);
        }
        subMenuTemp.forEach(setPos);
        //console.log("========================subMenuTemp", subMenuTemp);
  
        subMenu.items = subMenuTemp.filter((e) => typeof(e.show) != "undefined" || false ? e.show : false);
        return subMenu;
      }
      
      subMenu.items = subMenu.items.filter((e) => typeof(e.show) != "undefined" ? e.show : false);
      return subMenu;
    },
    getActiveSubMenuItems(_, getters) {
      if (!getters.getActiveSubMenu.items) return [];
      return getters.getActiveSubMenu.items.sort((a, b) => typeof(a.position) != "undefined" ? a.position - b.position : false);
      //return getters.getActiveSubMenu.items;
    },
    getActiveSubMenuItemsLenght(_, getters) {
      return getters.getActiveSubMenuItems.length;
    },
    getActiveSubMenuBackground(_, getters) {
      return getters.getActiveSubMenu.backgroundUrl;
    },
    getActiveSubMenuElementIndex(_, getters) {
      return getters.getActiveSubMenu.currentIndex;
    },
    getActiveSubMenuItem(_, getters) {
      return (getters.getActiveSubMenuItems[getters.getActiveSubMenuElementIndex] || {});
    },
    getActiveSubMenuItemType(_, getters) {
      return getters.getActiveSubMenuItem.type;
    },
    getActiveSubMenuItemActionUrl(_, getters) {
      return getters.getActiveSubMenuItem.actionUrl;
    },
    getIsLanguageSelected(state) {
      return state.isLanguageSelected;
    },
    getLangSubMenu(state) {
      return state.subMenuMap.language;
    },
    getHasNextAction(state) {
      return !!state.nextAction;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js